import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ZoneService } from 'src/app/core/services/zone.service';
import { ToastService } from 'src/app/core/services/toast.service';

@Component({
  selector: 'app-liste-zones',
  templateUrl: './liste-zones.component.html',
  styleUrls: ['./liste-zones.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ListeZonesComponent implements OnInit {

  colonnesAffichees: string[] = ['nom', 'description', 'ville', 'actions'];
  sourceDonnees: MatTableDataSource<any>;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  indicateurChargement = true;
  totalEnregistrements: number = 0;

  constructor(
    public zonesService: ZoneService,
    private router: Router,
    private toast: ToastService
  ) {
    this.sourceDonnees = new MatTableDataSource<any>([]);
  }

  ngOnInit(): void {
    this.chargerDonnees();
    this.zonesService.obtenirListeZones(0, 500);
  }

  ngAfterViewInit() {
    this.sourceDonnees.paginator = this.paginator;
    this.sourceDonnees.sort = this.sort;
  }

  chargerDonnees() {
    this.zonesService.donnees$.subscribe(
      donnees => {
        this.sourceDonnees.data = donnees;
        this.totalEnregistrements = donnees.length;
        this.indicateurChargement = false;
      },
      erreur => {
        console.error('Erreur lors de la récupération des données', erreur);
        this.indicateurChargement = false;
      }
    );
  }

  appliquerFiltre(event: Event) {
    const valeurFiltre = (event.target as HTMLInputElement).value;
    this.sourceDonnees.filter = valeurFiltre.trim().toLowerCase();
    if (this.sourceDonnees.paginator) {
      this.sourceDonnees.paginator.firstPage();
    }
  }

  ajouterZone() {
    this.router.navigate(['/zone/enregistrer']);
  }

  modifierZone(id: number) {
    this.router.navigate(['/zone/enregistrer', id]);
  }

  supprimerZone(zone: any) {
    this.toast.confirmer(
      `Êtes-vous sûr de vouloir supprimer la zone "${zone.nom}" ?`,
      'Confirmation de suppression'
    ).subscribe(confirme => {
      if (confirme) {
        this.zonesService.supprimerZone(zone.id).subscribe({
          next: () => {
            this.toast.succes('Zone supprimée avec succès', 'Succès');
            // Mise à jour immédiate du tableau côté UI
            const donneesMaj = this.sourceDonnees.data.filter(z => z.id !== zone.id);
            this.sourceDonnees.data = donneesMaj;
            this.totalEnregistrements = donneesMaj.length;
            if (this.sourceDonnees.paginator) {
              this.sourceDonnees.paginator.length = this.totalEnregistrements;
              // Revenir à la première page si la page courante devient vide
              const pageIndex = this.sourceDonnees.paginator.pageIndex;
              const pageSize = this.sourceDonnees.paginator.pageSize;
              const nbPages = Math.ceil(this.totalEnregistrements / pageSize);
              if (pageIndex >= nbPages && pageIndex > 0) {
                this.paginator.previousPage();
              }
            }
            // Resynchroniser depuis l'API
            this.zonesService.obtenirListeZones(0, 500);
          },
          error: (err) => {
            this.toast.erreur(err?.message || 'Erreur lors de la suppression', 'Erreur');
          }
        });
      }
    });
  }
}
